import { createContext } from 'react';

export const onboardingProcesses = {
  PROPERTY_TYPE: 'PROPERTY_TYPE',
  RESIDENT_TYPE: 'RESIDENT_TYPE',
  PROPERTY_ADDRESS: 'PROPERTY_ADDRESS',
  PROPERTY_NAME: 'PROPERTY_NAME',
  COVER_PHOTO: 'COVER_PHOTO',
  BUSINESS_INFO: 'BUSINESS_INFO',
  SUCCESSFUL: 'SUCCESSFUL',
  RECALLED_TO: 'RECALLED_TO',
};

const OnboardingContext = createContext({
  process: undefined,
});

export default OnboardingContext;
